export class OrchestratorThread {
    constructor(subscription, threadId) {
        this.attachedEvents = new Set();
        this.disposed = false;
        this.subscription = subscription;
        this.threadId = threadId !== null && threadId !== void 0 ? threadId : this.generateThreadId();
    }
    generateThreadId() {
        if (typeof crypto !== "undefined" &&
            typeof crypto.randomUUID === "function") {
            return crypto.randomUUID();
        }
        return `thread_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    }
    ensureActive() {
        if (this.disposed) {
            throw new Error(`OrchestratorThread ${this.threadId} has been disposed`);
        }
    }
    async push(event, data, options) {
        this.ensureActive();
        const opts = { ...(options !== null && options !== void 0 ? options : {}), ThreadID: this.threadId };
        this.subscription.push(event, data, opts);
    }
    listen(callback) {
        this.ensureActive();
        this.subscription.attachThreadListener(this.threadId, callback);
        this.attachedEvents.add("all");
    }
    bind(event, callback) {
        this.ensureActive();
        this.subscription.attachThreadBind(this.threadId, event, callback);
        this.attachedEvents.add(event);
    }
    remove(event, callback) {
        if (this.disposed)
            return;
        this.subscription.detachThreadListener(this.threadId, event, callback);
        if (!callback) {
            this.attachedEvents.delete(event);
        }
    }
    dispose() {
        if (this.disposed)
            return;
        this.disposed = true;
        for (const event of this.attachedEvents) {
            this.subscription.detachThreadListener(this.threadId, event);
        }
        this.attachedEvents.clear();
        this.subscription._unregisterThread(this.threadId);
    }
    isDisposed() {
        return this.disposed;
    }
    getId() {
        return this.threadId;
    }
}
